import Icon from "./icon";

export type { IconProps } from "./icon";

export { Icon };
